import React from "react"

import ListItemButton from "@mui/material/ListItemButton"
import { useTheme } from "@mui/material/styles"
import { useTranslation } from "react-i18next"
import { useMatch } from "react-router-dom"

import AnchorLink from "@components/AnchorLink"
import { IconWrapper } from "@components/IconWrapper"
import { lightVsDarkStyles } from "@helpers/lightVsDarkStyles"

import { toSentenceCase } from "@services/modifyStrings"

import { activeLinkStyles } from "../activeLinkStyles"
import { SubMenuItemBase } from "../types"

export interface SubMenuItemWithLink extends SubMenuItemBase {
  route: string
}

export const SubMenuItemWithLink: React.FC<SubMenuItemWithLink> = ({
  icon,
  translatedTextKey,
  route,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const isActive = useMatch(route)

  return (
    <AnchorLink url={route}>
      <ListItemButton
        sx={lightVsDarkStyles({
          ...activeLinkStyles({ isActive: Boolean(isActive), theme }),
        })}
      >
        {icon && (
          <div data-testid="submenu-item-icon">
            <IconWrapper color={() => "inherit"}>{icon}</IconWrapper>
          </div>
        )}

        {toSentenceCase(t(translatedTextKey))}
      </ListItemButton>
    </AnchorLink>
  )
}
